import { render } from "./Spinner.vue?vue&type=template&id=8dc2e09c"
import script from "./Spinner.vue?vue&type=script&lang=js"
export * from "./Spinner.vue?vue&type=script&lang=js"

import "./Spinner.vue?vue&type=style&index=0&id=8dc2e09c&lang=scss"
script.render = render

export default script